import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Same rule as the backend: readable label on the chosen colour.
const textOn = (hex) => {
  const lum = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4))
    .reduce((s, c, i) => s + c * [0.2126, 0.7152, 0.0722][i], 0);
  return lum > 0.4 ? "#0f172a" : "#ffffff";
};

export function WidgetSettings({ tid, src, onSaved, canManage }) {
  const api = useApi();
  const [w, setW] = useState(src.widget);
  const [busy, setBusy] = useState(false);
  const ok = /^#[0-9a-fA-F]{6}$/.test(w.button_color);
  const save = async () => {
    setBusy(true);
    try { await api.put(`/t/${tid}/lead-sources/${src.id}/widget`, w); toast.success("Widget aggiornato: si vede al prossimo caricamento del tuo sito"); onSaved(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-2 rounded-md border border-slate-200 p-3" data-testid={`widget-settings-${src.id}`}>
      <p className="text-xs font-medium text-slate-700">Aspetto e privacy del modulo</p>
      <label className="block text-[11px] text-slate-600">Link all'informativa privacy (https://)
        <Input value={w.privacy_url} disabled={!canManage} maxLength={500} onChange={(e) => setW({ ...w, privacy_url: e.target.value })} placeholder="https://tuosito.it/privacy" className="h-10" data-testid={`widget-privacy-${src.id}`} /></label>
      <div className="flex flex-wrap items-end gap-2">
        <label className="text-[11px] text-slate-600">Testo del pulsante
          <Input value={w.button_text} disabled={!canManage} maxLength={40} onChange={(e) => setW({ ...w, button_text: e.target.value })} className="h-10 w-48" data-testid={`widget-btn-text-${src.id}`} /></label>
        <label className="text-[11px] text-slate-600">Colore
          <input type="color" value={ok ? w.button_color : "#0f172a"} disabled={!canManage} onChange={(e) => setW({ ...w, button_color: e.target.value })} className="block h-10 w-14 cursor-pointer rounded border border-slate-200" aria-label="Colore del pulsante" data-testid={`widget-btn-color-${src.id}`} /></label>
        <span className="text-[11px] text-slate-500">Anteprima</span>
        <span className="rounded-lg px-4 py-2.5 text-sm" style={{ background: ok ? w.button_color : "#0f172a", color: textOn(ok ? w.button_color : "#0f172a") }} data-testid={`widget-btn-preview-${src.id}`}>{w.button_text || "Invia"}</span>
      </div>
      {!w.privacy_url && <p className="text-[11px] text-amber-700">Consigliato: senza link il visitatore vede solo il testo «informativa privacy».</p>}
      {canManage && <Button variant="outline" className="h-10" disabled={busy || !w.button_text.trim()} onClick={save} data-testid={`widget-save-${src.id}`}>{busy && <Loader2 size={14} className="mr-1.5 animate-spin" />}Salva aspetto</Button>}
    </div>);
}
